import { defineAsyncComponent } from "vue";
import {
    createColumnInlineCheckbox,
    createColumnInlineDate/*, createColumnInlineInput */
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { conditionFormChecker, putField } from "../../../../utils/form";
import lodash from "lodash";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../../components/attachment/AttachmentInlineList"));

export const createField = ({ props, data, key, group }) => {
    const { viewOnly, menuContext, inputTextType } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachments`,
                            fetchCriteria: data.attachment?.fetchCriteria,
                            ref: e => {
                                if (data.addAttachmentColumn) {
                                    return;
                                }
                                data.addAttachmentColumn = true;
                                e?.data.columns.splice(
                                    1,
                                    0,
                                    // createColumnInlineInput({
                                    //     title: () => i18n.global.t("views.request.attachment.documentNo"),
                                    //     dataIndex: "attribute.documentNo",
                                    //     items: model.attachments,
                                    //     useForm,
                                    //     itemsKey: `${prefix}attachments`,
                                    //     customRenderInputProp: ({ key }) =>
                                    //         lodash.merge(
                                    //             { disabled: viewOnly },
                                    //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                                    //         )
                                    // }),
                                    // createColumnInlineDate({
                                    //     title: () => i18n.global.t("views.request.attachment.documentDate"),
                                    //     dataIndex: "attribute.documentDate",
                                    //     items: model.attachments,
                                    //     useForm,
                                    //     itemsKey: `${prefix}attachments`,
                                    //     customRenderInputProp: ({ key }) =>
                                    //         lodash.merge(
                                    //             { disabled: viewOnly },
                                    //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                                    //         )
                                    // }),
                                    createColumnInlineCheckbox({
                                        visible: () => {
                                            const check = conditionFormChecker({
                                                props,
                                                data,
                                                executeKey: "visibleField",
                                                params: { field: { key }, model }
                                            });
                                            return check;
                                        },
                                        title: () => i18n.global.t("views.request.attachment.isVerify"),
                                        dataIndex: "isVerify",
                                        items: model.attachments,
                                        useForm,
                                        itemsKey: `${prefix}attachments`,
                                        customRenderInputProp: ({ key, record }) =>
                                            lodash.merge(
                                                {
                                                    disabled: viewOnly,
                                                    "onUpdate:checked": (checked) => {
                                                        if (checked) {
                                                            record.isReject = null;
                                                        }
                                                        record.isVerify = checked;
                                                        record.isSave = true;
                                                    }
                                                },
                                                conditionFormChecker({
                                                    props,
                                                    data,
                                                    executeKey: "inputPropField",
                                                    params: { field: { key } }
                                                })
                                            )
                                    }),
                                    createColumnInlineCheckbox({
                                        visible: () => {
                                            const check = conditionFormChecker({
                                                props,
                                                data,
                                                executeKey: "visibleField",
                                                params: { field: { key }, model }
                                            });
                                            return check;
                                        },
                                        title: () => i18n.global.t("views.request.attachment.isReject"),
                                        dataIndex: "isReject",
                                        items: model.attachments,
                                        useForm,
                                        itemsKey: `${prefix}attachments`,
                                        customRenderInputProp: ({ key, record }) =>
                                            lodash.merge(
                                                {
                                                    disabled: viewOnly,
                                                    "onUpdate:checked": (checked) => {
                                                        if (checked) {
                                                            record.isVerify = null;
                                                        }
                                                        record.isReject = checked;
                                                        record.isSave = true;
                                                    }
                                                },
                                                conditionFormChecker({
                                                    props,
                                                    data,
                                                    executeKey: "inputPropField",
                                                    params: { field: { key } }
                                                })
                                            ),
                                    }),
                                    createColumnInlineDate({
                                        title: () => i18n.global.t("views.request.attachment.documentExpiredDate"),
                                        dataIndex: "attribute.documentExpiredDate",
                                        items: model.attachments,
                                        useForm,
                                        itemsKey: `${prefix}attachments`,
                                        customRenderInputProp: ({ key }) =>
                                            lodash.merge(
                                                { disabled: viewOnly },
                                                conditionFormChecker({
                                                    props,
                                                    data,
                                                    executeKey: "inputPropField",
                                                    params: { field: { key } }
                                                })
                                            )
                                    })
                                );
                            },
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            group: group,
                            inputTextType: inputTextType
                        },
                        conditionFormChecker({
                            props,
                            data,
                            executeKey: "inputPropField",
                            params: { componentKey: "AttachmentInlineList" }
                        })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};
